import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import PortalSidebar from './PortalSidebar';
import PortalTopbar from './PortalTopbar';
import { tokens } from '../../theme/theme';

export default function PortalLayout() {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: tokens.bg.default }}>
      <PortalSidebar />
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <PortalTopbar />
        <Box component="main" sx={{ flexGrow: 1, p: 3, overflowX: 'hidden' }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
